<div class="search-container">
  <form class="form-search-bar" [formGroup]="searchForm" (ngSubmit)="handleSubmit()">

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'admin.weee-system.name' |translate}}</mat-label>
      <input matInput type="text" [formControl]="descriptionControl" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'admin.countries.country' |translate}} {{'admin.countries.name' |translate}}</mat-label>
      <input matInput type="text" [formControl]="countryNameControl" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'admin.weee-system.member' |translate}}</mat-label>
      <mat-select [formControl]="isMemberControl">
        <mat-option value="">-</mat-option>
        <mat-option [value]="true">Member</mat-option>
        <mat-option [value]="false">Not member</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'admin.countries.status' |translate}}</mat-label>
      <mat-select [formControl]="statusControl">
        <mat-option value="">-</mat-option>
        <mat-option [value]="2">Active</mat-option>
        <mat-option [value]="1">Inactive</mat-option>
      </mat-select>
    </mat-form-field>

    <button type="reset" mat-raised-button (click)="clean()">Clean</button>
    <button type="submit" mat-raised-button color="primary">Apply</button>
  </form>
</div>
